import { cva } from "class-variance-authority";

export const iconVariants = cva("inline-flex items-center justify-center", {
  variants: {
    size: {
      xs: "h-3 w-3",
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-6 w-6",
      xl: "h-8 w-8",
      "2xl": "h-10 w-10",
      "3xl": "h-12 w-12",
      "4xl": "h-16 w-16",
      "5xl": "h-20 w-20",
      "6xl": "h-24 w-24",
    },
    color: {
      default: "text-current",
      primary: "text-primary",
      secondary: "text-secondary",
      muted: "text-muted-foreground",
      success: "text-green-600",
      warning: "text-yellow-600",
      danger: "text-red-600",
    },
  },
  defaultVariants: {
    size: "md",
    color: "default",
  },
});
